(function(){
  var css=`.card__inner{position:relative;}.wishlist-card-btn{position:absolute;top:1rem;right:1rem;background:rgba(253,251,247,0.93);border:none;cursor:pointer;width:3.6rem;height:3.6rem;border-radius:50%;display:flex;align-items:center;justify-content:center;z-index:3;transition:transform .2s ease,background .2s ease;padding:0;}.wishlist-card-btn svg{width:1.8rem;height:1.8rem;color:#1a1118;transition:fill .2s ease,stroke .2s ease;pointer-events:none;}.wishlist-card-btn.wishlist-active svg{fill:#c0435a;stroke:#c0435a;}.wishlist-card-btn:hover{transform:scale(1.1);background:#fff;}@keyframes wishlist-bounce{0%,100%{transform:scale(1);}50%{transform:scale(1.25);}}.wishlist-card-btn.wishlist-bounce{animation:wishlist-bounce .3s ease;}.lashop-wishlist-count{position:absolute;top:-6px;right:-6px;background:#c0435a;color:#fff;font-size:.9rem;font-weight:700;min-width:1.8rem;height:1.8rem;border-radius:50%;display:none;align-items:center;justify-content:center;line-height:1;pointer-events:none;}.lashop-wishlist-btn{position:relative;display:inline-flex;align-items:center;justify-content:center;}`;var s=document.createElement('style');s.id='lashop-wishlist-styles';s.textContent=css;document.head.appendChild(s);

  var KEY='lashop_wishlist';

  function getItems(){try{return JSON.parse(localStorage.getItem(KEY)||'[]');}catch(e){return [];}}
  function saveItems(items){localStorage.setItem(KEY,JSON.stringify(items));updateCounts();updateButtons();}
  function hasItem(h){return getItems().some(function(i){return i.handle===h;});}

  function toggleItem(h,title,price,image,url){
    var items=getItems();
    var idx=items.findIndex(function(i){return i.handle===h;});
    if(idx>-1){items.splice(idx,1);saveItems(items);return false;}
    else{items.push({handle:h,title:title,price:price,image:image,url:url});saveItems(items);return true;}
  }

  function updateCounts(){
    var count=getItems().length;
    document.querySelectorAll('.lashop-wishlist-count').forEach(function(el){
      el.textContent=count>0?count:'';
      el.style.display=count>0?'flex':'none';
    });
  }

  function updateButtons(){
    document.querySelectorAll('[data-wishlist-btn]').forEach(function(btn){
      var h=btn.dataset.handle;
      var active=hasItem(h);
      btn.classList.toggle('wishlist-active',active);
      btn.setAttribute('aria-label',active?'Hiq nga lista e dëshirave':'Shto në listën e dëshirave');
    });
  }

  document.addEventListener('click',function(e){
    var btn=e.target.closest('[data-wishlist-btn]');
    if(!btn)return;
    e.preventDefault();e.stopPropagation();
    var h=btn.dataset.handle;
    toggleItem(h,btn.dataset.title||'',btn.dataset.price||'',btn.dataset.image||'',btn.dataset.url||'');
    btn.classList.add('wishlist-bounce');
    setTimeout(function(){btn.classList.remove('wishlist-bounce');},400);
  });

  function init(){updateCounts();updateButtons();}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}

  window.LashopWishlist={
    getItems:getItems,
    removeItem:function(h){var items=getItems().filter(function(i){return i.handle!==h;});saveItems(items);}
  };
})();
